import {
  useAuditReportsGetBlueprintMetadataMetadata,
  useAuditReportsGetReportDefinitionById,
} from '@mi-front/api-v2';

/**
 * Hook to load blueprint and definition data for the report definition editor by definition ID.
 * First loads the definition by ID, then fetches the blueprint using the definition's reportType and blueprintVersion.
 */
export function useReportDefinitionQuery(id: string) {
  const definitionQuery = useAuditReportsGetReportDefinitionById(id, {
    query: {
      enabled: !!id,
    },
  });

  const definition = definitionQuery.data;

  const blueprintQuery = useAuditReportsGetBlueprintMetadataMetadata(
    definition?.reportType || '',
    definition?.blueprintVersion ? { blueprintVersion: definition.blueprintVersion } : undefined,
    {
      query: {
        enabled: !!definition,
      },
    },
  );

  return {
    blueprintQuery,
    definitionQuery,
  };
}
